var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelveDashboardOrderStatusCratesVerified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.854614,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#E9F6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 15.8546H12C11.4477 15.8546 11 16.3023 11 16.8546V19.8546C11 20.4069 11.4477 20.8546 12 20.8546H36C36.5523 20.8546 37 20.4069 37 19.8546V16.8546C37 16.3023 36.5523 15.8546 36 15.8546Z",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.8546V32.8546C35 33.1198 34.8946 33.3742 34.7071 33.5617C34.5196 33.7493 34.2652 33.8546 34 33.8546H14C13.7348 33.8546 13.4804 33.7493 13.2929 33.5617C13.1054 33.3742 13 33.1198 13 32.8546V20.8546",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25.8546H27",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelveDashboardOrderStatusCratesVerified);
export default __webpack_public_path__ + "static/media/delve-dashboard-order-status-crates-verified.f1ee850df7bf4972c2242372a890521e54f2ebe548ec7f9b9580e637bfa31935.svg";
export { ForwardRef as ReactComponent };